import React from "react";
import { Droplets, Wind, CloudRain, Cloud } from "lucide-react";
import { weatherIcon, skyGradient } from "./weatherMeta";

const Metric = ({ Icon, value, label }) => (
  <div className="flex flex-col items-center rounded-2xl bg-white/12 py-2.5">
    <Icon size={16} color="#fff" className="opacity-80" strokeWidth={2.2} />
    <div className="font-head mt-1 text-sm font-bold text-white">{value}</div>
    <div className="text-[10px] font-medium text-white/60">{label}</div>
  </div>
);

const WeatherCard = ({ w }) => {
  if (!w) {
    return <div className="h-56 animate-pulse rounded-[1.75rem] bg-slate-200" data-testid="weather-card-loading" />;
  }
  const Icon = weatherIcon(w.icon);
  return (
    <div
      className="relative overflow-hidden rounded-[1.75rem] p-6 text-white"
      style={{ background: skyGradient(w.icon, w.storm_status), boxShadow: "0 12px 34px rgba(10,42,107,0.30)" }}
      data-testid="weather-card"
    >
      <div className="flex items-start justify-between">
        <div>
          <div className="text-sm font-semibold text-white/70">{w.location}</div>
          <div className="font-head text-5xl font-extrabold leading-none" data-testid="weather-temp">{Math.round(w.temperature_c)}°</div>
          <div className="mt-1.5 text-base font-bold">{w.condition}</div>
          <div className="text-sm text-white/70">Feels like {Math.round(w.feels_like_c)}°</div>
        </div>
        <Icon size={64} color="#fff" strokeWidth={1.6} className="opacity-90" />
      </div>

      {w.summary && <p className="mt-4 text-sm leading-relaxed text-white/85">{w.summary}</p>}

      <div className="mt-5 grid grid-cols-4 gap-2.5">
        <Metric Icon={Droplets} value={`${w.humidity_pct}%`} label="Humidity" />
        <Metric Icon={Wind} value={Math.round(w.wind_kmh)} label="km/h wind" />
        <Metric Icon={CloudRain} value={w.rain_mm} label="mm rain" />
        <Metric Icon={Cloud} value={`${w.cloud_pct}%`} label="cloud" />
      </div>
    </div>
  );
};

export default WeatherCard;
